import React from 'react';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      number: "01",
      title: "Регистрация",
      description: "Создайте аккаунт за несколько секунд. Укажите email - данные для входа придут вам на почту, и вы готовы к магии ИИ.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      )
    },
    {
      number: "02",
      title: "Выбор тарифа",
      description: "Выберите подходящий план",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
        </svg>
      )
    },
    {
      number: "03",
      title: "Создание запроса",
      description: "Опишите, что вам нужно. Будь то статья, пост в соцсети или креативный текст - просто напишите свой запрос.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      )
    },
    {
      number: "04",
      title: "Получение результата",
      description: "Наблюдайте, как ИИ создает ваш контент в реальном времени. Результат появляется мгновенно, готовый к использованию.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    }
  ];

  return (
    <section id="how-it-works" className="py-20 px-4 bg-lunar-900/50">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-elegant font-bold text-white mb-6">
            Как это 
            <span className="bg-gradient-to-r from-mystic-400 to-moonlight-400 bg-clip-text text-transparent font-elegant"> работает</span>?
          </h2>
          <p className="text-xl text-lunar-300 max-w-3xl mx-auto font-elegant">
            Четыре простых шага отделяют вас от магии создания уникального контента с помощью ИИ
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-mystic-600 to-transparent z-0"></div>
              )}
              
              <div className="relative z-10 text-center">
                {/* Step Number */}
                <div className="inline-flex items-center justify-center w-16 h-16 bg-mystic-gradient rounded-full text-white font-bold text-xl mb-6">
                  {step.number}
                </div>
                
                {/* Icon */}
                <div className="w-12 h-12 bg-lunar-800 rounded-full flex items-center justify-center mx-auto mb-4 text-mystic-400">
                  {step.icon}
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-4">{step.title}</h3>
                <p className="text-lunar-400 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Mystical Elements */}
        <div className="mt-12 flex justify-center space-x-8 text-mystic-600">
          <div className="w-2 h-2 bg-mystic-600 rounded-full animate-pulse"></div>
          <div className="w-2 h-2 bg-mystic-600 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
          <div className="w-2 h-2 bg-mystic-600 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;